export const toCSSVars = (tokens, prefix) => {
    return Object.entries(tokens).map(([key, value]) => prefix ? `--${prefix}-${key}: ${value};` : `--${key}: ${value};`);
};
